import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { BonusLogic } from './BonusLogic';
import { GameLogic } from '../GameLogic';
import { BonusTypeEnum } from '../../Models/Game/BonusModel';

import BonusContants from '../../Constants/BonusContants';

@Singleton
export class BonusCalculatorLogic extends BonusLogic {
    constructor(
        @Inject private _model: GameModel,
        @Inject private _modelEvents: ModelEvents
    ) {
        super();

        this._config = BonusContants.find(
            o => o.type === BonusTypeEnum.calculator
        );
    }

    public apply(gameLogic: GameLogic): void {
        super.apply(gameLogic);

        // TODO: заменить isBonusDoubleScoreActive и вынести логику в этот класс
        this._gameLogic.setBonusDoubleScoreActive(true);
    }

    public cancel(): void {
        super.cancel();
    }

    public destroy(): void {
        super.destroy();
    }

    public update(frameTime): void {}
}
